"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledReEnrichAlert = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledReEnrichAlert = styled_components_1.default.div `
  display: flex;
  align-items: center;
  box-shadow: ${ui_components_1.shadows.card};
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(2)};
  background-color: ${ui_components_1.baseColors.primaryBlue100};
  border: 1px solid ${ui_components_1.baseColors.primaryBlue200};
  border-radius: 4px;
  font-size: 0.875rem;

  button {
    margin-left: auto;
    flex: 0 0 auto;
  }
`;
